module.exports = __webpack_public_path__ + "img/组 18-6.247bc109.png";